import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// When a page was opened from the Day Book (?return=daybook),
// pressing Escape returns straight to the Day Book view.
export function useDayBookReturn() {
  const navigate = useNavigate();
  const location = useLocation();
  const p = new URLSearchParams(location.search).get("return") || "";
  const target = p === "inventory" ? "/ledger-views?view=inventory-books"
    : p === "accbooks" ? "/ledger-views?view=account-books"
    : p === "daybook" ? "/ledger-views?view=day-book" : "";
  const active = !!target;
  useEffect(() => {
    if (!active) return;
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        navigate(target);
      }
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [active, target, navigate]);
  // Return the target path so pages can navigate back after Save/Accept too.
  return target;
}
